module.exports = __webpack_public_path__ + "img/parking_hover_c3d5510.png";